import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";
import { MessageProvider } from "./context/MessageContext";
import { AuthProvider } from "./context/AuthContext";
import MessageList from "./components/ui/MessageList";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <AuthProvider>
      <MessageProvider>
        <App />
        <MessageList /> {/* always visible */}
      </MessageProvider>
    </AuthProvider>
  </BrowserRouter>
);
